import { ref } from 'vue'

const SESSION_TIMEOUT = 25 * 60 * 1000 // 25 minutes in milliseconds
let timeoutId: number | null = null
const isSessionExpired = ref(false)

export function useSessionTimeout() {
  const resetTimeout = () => {
    if (timeoutId) {
      window.clearTimeout(timeoutId)
    }
    
    timeoutId = window.setTimeout(() => {
      isSessionExpired.value = true
    }, SESSION_TIMEOUT)
  }

  const startSessionTimer = () => {
    // Reset session expired state
    isSessionExpired.value = false
    
    // Set up event listeners for user activity only on our page
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart']
    
    const handleUserActivity = () => {
      // Only reset timeout if user is interacting with our page
      if (document.hasFocus()) {
        resetTimeout()
      }
    }

    // Add event listeners
    events.forEach(event => {
      window.addEventListener(event, handleUserActivity)
    })

    // Initial timeout
    resetTimeout()

    // Return cleanup function
    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId)
      }
      events.forEach(event => {
        window.removeEventListener(event, handleUserActivity)
      })
    }
  }

  return {
    isSessionExpired,
    startSessionTimer
  }
}
